import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import cfg from '../config';

const EmailVerification = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const [status, setStatus] = useState('loading'); // loading | success | error
    const [message, setMessage] = useState('');

    useEffect(() => {
        if (!token) {
            setStatus('info');
            setMessage('Bitte schau in dein Postfach und klicke auf den Bestätigungslink.');
            return;
        }

        axios.get(`/api/verify-email?token=${token}`)
            .then(res => {
                setStatus('success');
                setMessage(res.data.message || 'E-Mail-Adresse erfolgreich bestätigt!');
            })
            .catch(err => {
                setStatus('error');
                setMessage(err.response?.data?.message || 'Ungültiger oder abgelaufener Bestätigungslink.');
            });
    }, [token]);

    const iconMap = { loading: '⏳', success: '✅', error: '❌', info: '📧' };
    const alertMap = { loading: 'alert-secondary', success: 'alert-success', error: 'alert-danger', info: 'alert-info' };

    return (
        <div className="d-flex align-items-center justify-content-center min-vh-100 bg-dark">
            <div className="card bg-secondary text-white p-4 shadow-lg" style={{ maxWidth: '480px', width: '100%' }}>
                <div className="text-center mb-3" style={{ fontSize: '3rem' }}>
                    {iconMap[status]}
                </div>
                <h4 className="text-center mb-3">E-Mail-Verifizierung</h4>

                {status === 'loading' && (
                    <div className="text-center">
                        <div className="spinner-border text-warning mb-3" role="status" />
                        <p>Link wird überprüft...</p>
                    </div>
                )}

                {status !== 'loading' && (
                    <div className={`alert ${alertMap[status]}`}>{message}</div>
                )}

                {status === 'success' && (
                    <p className="text-center text-secondary small">
                        Dein Zugang wird nun von {cfg.adminRoleName} freigeschaltet. Du erhältst eine Benachrichtigung.
                    </p>
                )}

                <div className="text-center mt-3">
                    <Link to="/login" className="btn btn-warning">Zum Login</Link>
                </div>
            </div>
        </div>
    );
};

export default EmailVerification;
